<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Från"
        type="datetime-local"
        persistent-hint
        outlined
        v-model="start"
        :rules="[required]"
        :disabled="readonly"
      />
    </v-col>
    <v-col>
      <v-text-field
        label="Till"
        type="datetime-local"
        persistent-hint
        outlined
        v-model="end"
        :rules="[required]"
        :disabled="readonly"
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'TibBannerTimeStartInput',

  props: {
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    start: sync('tibBanner/model@time_start'),
    end: sync('tibBanner/model@time_end')
  }
}
</script>
